export enum HighlightingTypes {
  Word = 'Word',
  Line = 'Line',
  Sentence = 'Sentence',
  WordBeforeTextNote = 'WordBeforeTextNote',
}

export enum ExtractTagsStep {
  Nums,
  NumsArray,
  NumsData
}

export enum TagsName {
  AsgardInfo = 'AsgardInfo',
  SensotecInfo = 'SensotecInfo',
  SprintInfo = 'SprintInfo',
  AdibibInfo = 'AdibibInfo'
}

export enum PageBoxes {
  Media = 0,
  Crop = 1,
}

export enum AnnotationTypes {
  FreeText = 'FreeText',
  StickyNote = 'StickyNote',
  Rectangle = 'Rectangle',
  Marker = 'Highlight',
}

export enum PdfFitModes {
  FitPage = 'FitPage',
  FitWidth = 'FitWidth',
  Zoom = 'Zoom',
}

export enum PdfViewerLayoutModes {
  Single = 'Single',
  Continuous = 'Continuous',
  Facing = 'Facing',
  FacingContinuous = 'FacingContinuous',
  FacingCover = 'CoverFacing',
  FacingCoverContinuous = 'Cover'
}

export enum PdfTools {
  AnnotationCreateRectangle = 'AnnotationCreateRectangle',
  AnnotationCreateEllipse = 'AnnotationCreateEllipse',
  AnnotationCreateArrow = 'AnnotationCreateArrow',
  AnnotationCreateLine = 'AnnotationCreateLine',
  AnnotationCreateFreeHand = 'AnnotationCreateFreeHand',
  AnnotationCreateTextHighlight = 'AnnotationCreateTextHighlight',
  AnnotationEdit = 'AnnotationEdit',
  Pan = 'Pan',
}

export enum PdfStrokeColor {
  LightBlue = '#80DCFF',
  Blue = '#0075DA',
  DarkBlue = '#00193D',
  LightGreen = '#01FF70',
  Green = '#2ACD3D',
  DarkGreen = '#3A9A70',
  Yellow = '#FFDD00',
  Orange = '#FF8614',
  Red = '#FF0000',
  Pink = '#F009BF',
  Purple = '#B206CA',
  DarkPurple = '#860C4A',
  LightGray = '#DEDEDE',
  Gray = '#ABACAC',
  Black = '#080808'
}

export enum PdfToolType {
  Rectangle = 'Rectangle',
  Ellipse = 'Ellipse',
  Arrow = 'Arrow',
  Line = 'Line',
  FreeHand = 'FreeHand',
  Marker = 'Marker',
  Default = 'Default',
  Pan = 'Pan'
}

export enum PdfLineStyle {
  Solid = 'Solid',
  Dashed = 'Dashed',
  Longdash = 'Longdash',
  Dotted = 'Dotted'
}

export enum PdfAnnotationActions {
  Selected = 'selected',
  Deselected = 'deselected',
  Modified = 'modify',
  Added = 'add',
  Deleted = 'delete'
}

export enum DocumentMarkersMode {
  Marker = 'Marker',
  Eraser = 'Eraser',
  None = 'None'
}

/* see pdftron-custom-styles.css */
export enum CustomDocviewerCursorStyles {
  erase = 'erase',
  textnote = 'textnote',
  stickynote = 'stickynote',
  audiomaker = 'audiomaker',
  yellow = 'yellow',
  orange = 'orange',
  green = 'green',
  blue = 'blue',
  pink = 'pink'
}

export enum NavigationModes {
  CONTINUOUS = 'CONTINUOUS',
  PAGE_BY_PAGE = 'PAGE_BY_PAGE'
}
